import yup from "utilities/form/yup";

import { type ILineItemGroup } from "commonComponents/utilities/LineItemContainer/types/LineItem.interfaces";
import {
    baseLineItemSchemaDefinition,
    markupLineItemSchemaDefinition,
} from "commonComponents/utilities/LineItemContainer/types/LineItem.schemas";

import { type WorksheetLineItem } from "entity/estimate/common/estimate.common.types";

export type LineItemDetailsFormActions =
    | undefined
    | "save"
    | "saveAndClose"
    | "saveAndNew"
    | "delete";

const baseLineItemEstimatesSchemaDefinition = {
    ...baseLineItemSchemaDefinition,
    ...markupLineItemSchemaDefinition,
    profit: yup.number().label("Profit"),
    assemblyId: yup.number().nullable().label("Assembly"),
    taxGroupId: yup.number().label("Tax"),
    parentId: yup.number().nullable().label("Parent group / subgroup"),

    // providing all properties even if not used in validation
    builderId: yup.mixed().notRequired(),
    jobId: yup.mixed().notRequired(),
    lineItemType: yup.mixed().notRequired(),
    costCategoryId: yup.mixed().notRequired(),
    costItemId: yup.mixed().notRequired(),
    amountInvoiced: yup.mixed().notRequired(),
    totalWithTax: yup.mixed().notRequired(),
    isEditable: yup.mixed().notRequired(),
    formatId: yup.mixed().notRequired(),
    costCategoryFormatId: yup.mixed().notRequired(),
    displayOrder: yup.mixed().notRequired(),
    hasRelatedPurchaseOrder: yup.mixed().notRequired(),
    relatedGeneralItemId: yup.mixed().notRequired(),
    relatedItems: yup.mixed().notRequired(),
    relatedPurchaseOrderLineItemId: yup.mixed().notRequired(),
    selectionOptionGroupId: yup.mixed().notRequired(),
};

type BaseLineItemEstimatesSchemaType = typeof baseLineItemEstimatesSchemaDefinition;
export function getLineItemEstimatesSchema(
    getExtendedSchema: (
        baseSchema: BaseLineItemEstimatesSchemaType,
    ) => BaseLineItemEstimatesSchemaType = (s) => s,
): yup.ObjectSchema<WorksheetLineItem> {
    return yup.object<WorksheetLineItem>(getExtendedSchema(baseLineItemEstimatesSchemaDefinition));
}

export const lineItemGroupSchema = yup.object().shape<ILineItemGroup<WorksheetLineItem>>({
    id: yup.number(),
    title: yup.string().required().label("Title"),
    isExpanded: yup.boolean(),
    items: yup.array(),
});
